/**
 * @file Pan-zoom.tsx
 * @module PanZoomControl
 * @description Panoramēšanas/tālummaiņas (Pan-Zoom) vadīkla Karšu pārlūkam.
 *              Aktivizē OpenLayers DragZoom interakciju, kas ļauj lietotājam
 *              uzzīmēt taisnstūri kartē, lai tuvinātu atlasīto apgabalu.
 *              Reģistrē sevi kā OpenLayers Control elementu.
 */
import { useEffect, useRef, useState } from "react";

import { useObservable } from "@ngneat/use-observable";
import { DragZoom } from "ol/interaction";
import * as condition from "ol/events/condition";

import { getMapStore } from "../Map.repository";
import { getSettingStore } from "../../settings/Settings.repository";
import { useTranslation } from "react-i18next";
import { Control } from "ol/control";

export default function PanZoomControl({ handlePanZoomChange }: any) {
	const [select, setSelected] = useState(false);
	const [props] = useObservable(getMapStore());
	const [setting] = useObservable(getSettingStore());
	const [mapStore] = useObservable(getMapStore());
	const panRef = useRef<HTMLDivElement | null>(null);
	const [t] = useTranslation();

	function classNames(...classes: string[]) {
		return classes.filter(Boolean).join(" ");
	}

	const dragZoomAlways = new DragZoom({
		condition: condition.always,
	});

	function togglePanZoom() {
		setSelected(!select);
		handlePanZoomChange(!select);
		props.map?.getInteractions().forEach((interaction) => {
			if (interaction instanceof DragZoom) {
				interaction.setActive(interaction.getActive() ? false : true);
			}
		});
	}

	useEffect(() => {
		if (!panRef.current || !mapStore.map) return;

		const panControl = new Control({ element: panRef.current });

		mapStore.map.addControl(panControl);
	}, [panRef, mapStore]);

	useEffect(() => {
		const map = props.map;
		if (map) {
			dragZoomAlways.setActive(false);
			map.addInteraction(dragZoomAlways);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.map]);

	return (
		<div
			ref={panRef}
			className={classNames(setting.showPanBtn ? "" : "!hidden", "ol-control right-2 top-52 sm:top-24 absolute hidden sm:block")}
			onClick={() => {
				togglePanZoom();
			}}
			title={t("panControl") ?? ""}
		>
			<button className={"hover:bg-gray-200" + (select ? "!bg-gray-500 !text-white hover:!bg-gray-600" : "")}>P</button>
		</div>
	);
}
